<template>
    <div>
    <b-row align-h="center">
      <b-col sm="12" xl="8">
        <h1 v-if="title" class="app-title mb-3">{{title}}</h1>
        <slot></slot>
      </b-col>
    </b-row>
    </div>
</template>

<script>
export default {
  props: {
    title: String
  }

}
</script>

<style>

</style>
